import Vue from 'vue'

const els = document.querySelectorAll("[id^='team-app--']")
if (els != null) {
  els.forEach((el) => {
    var vm = new Vue({
      data: () => {
        return {
          panelIsOpen: false
        }
      },
      delimiters: ['[[', ']]'],
      methods: {
        toggleOpen () {
          this.panelIsOpen = !this.panelIsOpen
        }
      },
      watch: {
        panelIsOpen: {
          handler: function (val) {
            this.$nextTick(() => {
              if (typeof this.$refs.closeBtn !== 'undefined') {
                this.$refs.closeBtn.focus()
              }
            })
          },
          deep: true
        }
      },
      mounted() {
        // Close modal with 'esc' key
        document.addEventListener("keydown", (e) => {
          if (e.keyCode == 27) {
            this.panelIsOpen = false
          }
        })
      }
    })
    vm.$mount(el)
  })
}
